var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Card', {
    staticClass: "base_info",
    attrs: {
      "shadow": ""
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "base-info-form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRules,
      "label-position": "top"
    }
  }, [_c('Row', {
    staticClass: "base-info-form__row",
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("cf0olz4", "应用名称"),
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "value": _vm.formData.name,
      "maxlength": "60"
    },
    on: {
      "on-change": _vm.changeName
    }
  })], 1)], 1), _c('Col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("k1e32", "状态"),
      "prop": "isHalt"
    }
  }, [_c('i-switch', {
    attrs: {
      "true-value": "F",
      "false-value": "T"
    },
    model: {
      value: _vm.formData.isHalt,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isHalt", $$v);
      },
      expression: "formData.isHalt"
    }
  })], 1)], 1), _c('Col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("fd8p2", "图标"),
      "prop": "icon"
    }
  }, [_c('upload-image', {
    model: {
      value: _vm.formData.icon,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "icon", $$v);
      },
      expression: "formData.icon"
    }
  })], 1)], 1), _c('Col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("bw5got4", "安全等级")
    }
  }, [_c('Rate', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.changeSecutity
    },
    model: {
      value: _vm.formData.securityLevel,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "securityLevel", $$v);
      },
      expression: "formData.securityLevel"
    }
  })], 1)], 1), _c('Col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("ceztdi4", "应用介绍")
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": "30",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": $t("3hiw6u8", "点击输入应用介绍")
    },
    model: {
      value: _vm.formData.introduction,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "introduction", $$v);
      },
      expression: "formData.introduction"
    }
  })], 1)], 1), _vm._language ? _c('Col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("ok372", "语言")
    }
  }, [_c('Select', {
    attrs: {
      "transfer": "",
      "value": _vm.languageValue
    },
    on: {
      "on-change": _vm.onChangeLanguage
    }
  }, _vm._l(_vm.languageList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 1)], 1)], 1) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "flex items-center justify-between flex-wrap"
  }, [_c('div', {
    staticClass: "right flex gap-2 flex-wrap w-[120px] flex justify-start"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v($t("e32z2", "保存"))])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };